import {spoolApi} from "@commons/features/varie/spool.api";

export const toolsReducers = {
    [spoolApi.reducerPath]: spoolApi.reducer,
}
export const toolsMiddlewares = [
    spoolApi.middleware,
]